import { clearUserSessionData, logoutKemsuWebSystem } from "~/domain/user-session"
import { api } from "~/shared/api"
import { isStandalone } from "~/shared/lib/utils"

export async function logout() {
	clearUserSessionData()

	if (!isStandalone()) {
		await logoutKemsuWebSystem()
	}

	await api.post("/security/auth/clear-tokens")

	location.replace("/main")
}
